<style scoped>
.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;

}

.customer-information {
    background: #fff;
    padding-bottom: 15px;
}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
}

.customer-information .col-itms.second {
    margin-left: 170px;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.select-box {
    overflow: hidden;
    /* margin: 0 0px 10px 30px; */
}

.box-left {
    height: 300px;
    padding: 0 20px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
    overflow-y: auto;
    margin-top: 20px;
}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">项目立项申请</div>
        </div>
        <div class="import-title">客户基础资料</div>
        <div class="customer-information">
            <!-- 第一行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>立项时间</div>
                    <el-date-picker value-format="yyyy-MM-dd" class="w300" type="date" placeholder="选择时间"
                        v-model="form.createProjectDate"></el-date-picker>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>立项人</div>
                    <el-input @focus="choosePerson('2')" class="w300" placeholder="请填写"
                        v-model="form.createProjectStaffName"></el-input>
                </div>
            </div>
            <!-- 第二行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>客户名称</div>
                    <el-select filterable allow-create default-first-option v-model="form.tenantName" @change="tenantChange"
                    @keydown.native="handleKeydown"
                        placeholder="请选择" class="w300">
                        <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
                        </el-option>
                    </el-select>
                </div>
                <!-- 新增字段 -->
                <div class="col-itms second">
                    <div class="title"><span>*</span>公司简称</div>
                    <el-input class="w300" maxlength="50" placeholder="请填写" v-model="form.abbreviation"></el-input>
                </div>
            </div>


            <!--第三行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司类型</div>
                    <el-select v-model="form.platformEnterpriseType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('平台企业类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>是否上市</div>
                    <el-radio-group v-model="form.isIpo">
                        <el-radio label="Y">是</el-radio>
                        <el-radio label="N">否</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <!--第四行 -->
            <div class="cols">

                <div class="col-itms" style="padding:10px 194px 10px 0;">
                    <div class="title"><span>*</span>有三方仓储</div>
                    <el-radio-group v-model="form.hasThirdPartyStorage">
                        <el-radio label="Y">是</el-radio>
                        <el-radio label="N">否</el-radio>
                    </el-radio-group>
                </div>

                <div class="col-itms second">
                    <div class="title"><span>*</span>配送能力</div>
                    <el-radio-group v-model="form.hasDistributeCapacity">
                        <el-radio label="Y">是</el-radio>
                        <el-radio label="N">否</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <!--第五行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司成立时间</div>
                    <el-date-picker value-format="yyyy-MM-dd" class="w300" type="date" placeholder="选择时间"
                        v-model="form.registerDate"></el-date-picker>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>注册资本(元)</div>
                    <el-input class="w300" type="text" maxlength="12" onkeyup="value=value.replace(/[^\d.]/g, '')"
                        placeholder="请填写" v-model="form.registerCapitalAmount"></el-input>
                </div>
            </div>
            <!--第六行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司组织形式</div>
                    <el-select v-model="form.companyType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('企业性质字典')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>行业地位</div>
                    <el-select v-model="form.industryPosition" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('行业地位')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <!-- 第7行 -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>经营规模</div>
                    <el-select v-model="form.businessScale" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('经营规模')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>经营范围</div>
                    <el-select v-model="form.businessScopeList" multiple placeholder="请选择，可多选" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('经营范围')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第8行 -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>主营品种类型</div>
                    <el-select v-model="form.mainProductCategoryList" multiple placeholder="请选择，可多选" filterable
                        class="w300">
                        <el-option v-for="item in getCodeListByKey('推广品类')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>主要下游客户</div>
                    <el-select v-model="form.downstreamCustomerList" placeholder="请选择,可多选" multiple filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('平台企业类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>


            <!-- 第9行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>主营业务类型</div>
                    <el-select v-model="form.businessTypeList" placeholder="请选择" multiple filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('主营业务类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>营销费用年支出额度</div>

                    <el-select v-model="form.marketingExpensePayLimit" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('营销费用年支出额度')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第10行  -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>公司营销费用支出对象</div>
                    <el-select v-model="form.marketingExpensePayObject" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('公司营销费用支出对象')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>开票类型</div>
                    <el-select v-model="form.invoiceType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('发票选项')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第11行  -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>业务员类型</div>
                    <el-select v-model="form.staffTypeList" multiple placeholder="请选择，可多选" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('业务员类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>业务人员日常拜访对象</div>
                    <el-select v-model="form.staffVisitObjectList" multiple placeholder="请选择，可多选" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('客户类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第12行  -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司法人</div>
                    <el-input maxlength="10" class="w300" placeholder="请填写" v-model="form.juridicalPerson"></el-input>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>司法官司</div>
                    <el-select v-model="form.lawsuitType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('司法官司')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第13行  -->
            <div class="cols">
                <div class="col-itms" style="padding:10px 194px 10px 0;">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>是否有信息部</div>
                    <el-radio-group v-model="form.hasItDept">
                        <el-radio label="Y">是</el-radio>
                        <el-radio label="N">否</el-radio>
                    </el-radio-group>
                </div>
                <div class="col-itms second">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>信息能力</div>
                    <el-select v-model="form.itAbility" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('高中低')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第14行  -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span style="color:#fff">*</span>对接系统</div>
                    <el-select v-model="form.linkSystemList" multiple placeholder="请选择，可多选" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('对接系统')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>客户定级</div>
                    <el-select v-model="form.customerGrade" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('客户定级')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- 第15行  -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span style="color:#fff">*</span>流通类型</div>
                    <el-select v-model="form.circulateType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('流通类型')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>年销售额（元）</div>
                    <el-input class="w300" type="text" maxlength="12" onkeyup="value=value.replace(/[^\d.]/g, '')"
                        placeholder="请填写" v-model="form.salesScaleAmount"></el-input>
                </div>
            </div>
            <!-- 第16行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>客户来源</div>
                    <el-select v-model="form.customerSource" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('客户来源')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="import-title second">联系方式</div>
        <div class="customer-information">
            <div class="cols">
                <!-- 新增字段 -->
                <div class="col-itms">
                    <div class="title"><span>*</span>所在省市区</div>
                    <el-cascader class="w300" clearable size="small" ref="cascaderFirst" @change="changeCityAndDis"
                        filterable :options="options" v-model="addressList" />
                </div>
                <div class="col-itms  second">
                    <div class="title"><span>*</span>详细地址</div>
                    <el-input class="w300" maxlength="100" placeholder="请填写" v-model="form.address"></el-input>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>业务联系人</div>
                    <el-input maxlength="10" class="w300" placeholder="请填写" v-model="form.contacts"></el-input>
                </div>
                <div class="col-itms  second">
                    <div class="title"><span>*</span>业务联系电话</div>
                    <el-input class="w300" :maxlength="20"
                        @input="form.contactsMobile = form.contactsMobile.replace(/[^\d\-\d]/g, '')" placeholder="请填写"
                        v-model="form.contactsMobile"></el-input>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms ">
                    <!-- 新增字段 -->
                    <div class="title"><span>*</span>公司电话</div>
                    <el-input class="w300" :maxlength="20" @input="form.tenantTel = form.tenantTel.replace(/[^\d\-\d]/g, '')"
                        placeholder="请填写" v-model="form.tenantTel"></el-input>
                </div>
            </div>


        </div>
        <div class="import-title second">合作信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>项目类型</div>
                    <el-select v-model="form.projectType" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in getCodeListByKey('合同内容分类')" :key="item.value" :label="item.text"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>合作点数(%)</div>
                    <el-input class="w300" onkeyup="value=value.replace(/[^\d.]/g, '')" maxlength="5" placeholder="请填写"
                        v-model="form.cooperateFeeRate"></el-input>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span style="color:#fff">*</span>商务费用(%)</div>
                    <el-input class="w300" onkeyup="value=value.replace(/[^\d.]/g, '')" maxlength="5" placeholder="请填写"
                        v-model="form.businessFeeRate"></el-input>
                </div>
                <div class="col-itms second">
                    <div class="title"><span style="color:#fff">*</span>商务费用(元)</div>
                    <el-input class="w300" onkeyup="value=value.replace(/[^\d.]/g, '')" maxlength="12" placeholder="请填写"
                        v-model="form.businessFee"></el-input>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>合作规模(元)</div>
                    <el-input class="w300" onkeyup="value=value.replace(/[^\d.]/g, '')" maxlength="12" placeholder="请填写"
                        v-model="form.cooperateScaleAmount"></el-input>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>项目关系人</div>
                    <el-input maxlength="10" class="w300" placeholder="请填写" v-model="form.projectRelationPerson"></el-input>
                </div>

            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span style="color:#fff">*</span>运营项目经理</div>
                    <el-input @focus="choosePerson('1')" class="w300" placeholder="请填写"
                        v-model="form.projectManagerName"></el-input>
                </div>

                <div class="col-itms second">
                    <div class="title"><span style="color:#fff">*</span>公司合伙人</div>
                    <el-input maxlength="10" class="w300" placeholder="请填写" v-model="form.cooperatePerson"></el-input>
                </div>
            </div>


        </div>
        <div class="import-title second">立项信息</div>
        <div class="customer-information">
            <div class="import-new-wrap">
                <div class="cols">
                    <div class="col-itms">
                        <div class="title"><span>*</span>立项申请表上传</div>
                        <el-upload class="upload-demo t-left" action="#" ref="createProject" :on-remove="handleMainRemove"
                            :file-list="createProjectFileList" accept=".xlsx,.xsl,.xls,.xlsm,.doc,.docx" :auto-upload="true"
                            :http-request="changeMainFile">
                            <el-button size="mini" icon="el-icon-my-import" style="margin-top: 8px; margin-bottom: 0"
                                type="importNew">导入文件</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="import-step-tip">当前支持xlsx、xsl、xls、xlsm、doc、docx格式文件，单个文件不得大于10M</div>
            </div>
            <div class="import-new-wrap">
                <div class="cols">
                    <div class="col-itms">
                        <div class="title"><span>*</span>客户分级表/需求调研表上传</div>
                        <el-upload class="upload-demo t-left" action="#" :file-list="gradeSurveyFileList"
                            accept=".xlsx,.xsl,.xls,.xlsm,.doc,.docx" :auto-upload="true" :http-request="changeSubFile"
                            :on-remove="handleSubRemove">
                            <el-button size="mini" icon="el-icon-my-import" style="margin-top: 8px; margin-bottom: 0"
                                type="importNew">导入文件</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="import-step-tip">当前支持xlsx、xsl、xls、xlsm、doc、docx格式文件，单个文件不得大于{{ fileSizeTip }}M</div>
            </div>

        </div>
        <div class="flow">
            <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
        <div class="submit-btn-box submit_btn_wrap">
            <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
            <el-button type="borderGreen"  size="small" v-if="form.approveState == 'N' || !guid" @click="saveTemp">保存</el-button>
            <el-button type="importNew" size="small" @click="saveReq">提交申请</el-button>
        </div>
        <!-- 选择人员 -->
        <ChoosePerson ref="choosePerson" :staffType="staffType" @onSelect="onPersonSelect"></ChoosePerson>
    </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import { bpmnroute } from '@/api/apiRoute';
import ChoosePerson from '@/components/person/choosePerson';
export default {
    components: {
        ChoosePerson
    },
    data() {
        return {
            tenantList: [],
            addressList: [],
            options: areaJson,
            staffType: 1,
            fileSizeTip: serverConfig.FILE_SIZE,
            fullscreenLoading: false,
            platformEnterpriseTypeList: [],//平台企业类型列表
            companyTypeList: [],//公司组织类型列表
            projectTypeList: [],//项目类型
            // staffList: [],
            guid: '',
            form: {
                downstreamCustomerList: [],
                platformEnterpriseType: '',//公司类型
                companyType: '',//公司组织形式
                createProjectStaffGuid: '',//立项人
                createProjectStaffName: '',
                createProjectDate: '',//立项时间
                hasThirdPartyStorage: 'N',//是否有三方仓储
                hasDistributeCapacity: 'N',//是否有配送能力
                tenantName: '',//客户名称
                address: '',//客户地址
                isIpo: 'N',//是否上市
                businessTypeList: '',//主营业务类型
                registerCapitalAmount: '',//注册资本
                registerDate: '',//注册时间
                juridicalPerson: '',//公司法人
                businessFee: '',//商务费用
                businessFeeRate: '',//商务费率
                cooperateFeeRate: '',//合作费率
                cooperatePerson: '',//合伙人
                projectRelationPerson: '',//项目关系人
                customerSource: '',//客户来源
                customerGrade: '',//客户定级
                contactsMobile: '',//联系电话
                contacts: '',//联系人
                salesScaleAmount: '',//销售规模
                cooperateScaleAmount: '',//合作规模
                projectManagerName: '',
                projectManagerGuid: '',

                abbreviation: '',//公司简称
                industryPosition: '',//行业地位
                businessScale: '',//经营规模
                businessScopeList: [],//经营范围
                marketingExpensePayLimit: '',//营销费用年支出额度
                marketingExpensePayObject: '',//公司营销费用支出对象
                invoiceType: '',//开票类型
                staffTypeList: [],//业务员类型
                staffVisitObjectList: [],//业务人员日常拜访对象
                lawsuitType: '',//司法官司
                hasItDept: 'N',//有无信息部
                itAbility: '',//信息能力
                linkSystemList: [],//对接系统
                circulateType: '',//流通类型
                tenantTel: '',//公司电话
                mainProductCategoryList: [],//主营品种类型
                province: null,
                city: null,
                district: null,
                venue: ''
            },

            createProjectFileList: [],
            gradeSurveyFileList: [],
            //流程相关
            iframeSh: false,
            iframeSrc: '',
        }
    },
    watch: {

    },
    created() {

        if (this.$route.query.form) {
            let form = JSON.parse(decodeURIComponent(this.$route.query.form));
            //文件
            form.createProjectFileList && form.createProjectFileList.forEach(item => {
                this.createProjectFileList = [{
                    name: item.fileName,
                    path: item.path
                }]
            })
            form.gradeSurveyFileList && form.gradeSurveyFileList.forEach(item => {
                this.gradeSurveyFileList = [{
                    name: item.fileName,
                    path: item.path
                }]
            })
            this.addressList = [];
            if (form.province) {
                this.addressList.push(form.province)
            }
            if (form.city) {
                this.addressList.push(form.city)
            }
            if (form.district) {
                this.addressList.push(form.district)
            }
            this.form = form;
            this.guid = form.guid;
        }
        this.getTenantList();
        this.getApprovalList();
    },
    methods: {
        handleKeydown(event) {
            // 阻止空格键输入
            const isSpaceKey = 
                event.key === ' ' || 
                event.key === 'Spacebar' || 
                event.code === 'Space' || 
                event.keyCode === 32;
            if (isSpaceKey) {
                event.preventDefault();
                return false;
            }
        },
        tenantChange(val) {
            let item = this.tenantList.filter(item => item.guid == val)
            if (item.length) { //自带的
                this.form.tenantName = item[0].tenantName;
                this.form.tenantGuid = item[0].guid;
                this.getTenantDetail(this.form.tenantGuid)
            } else { //手输的
                this.form.tenantName = val;
                this.form.tenantGuid = null;
            }
        },
        getTenantList() {
            let that = this;
            let req = {
                pageIndex: 1,
                pageSize: -1,
                enterpriseCates: this.$getValueListByKey('上游客户分类')
            }
            that.api.postJson(`/${serverConfig.msCustomerService}/tenant/get-project-apply-tenants`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    that.tenantList = res.data.data || [];
                } else {
                    that.$message.error(res.data.msg);
                }

            });
        },
        getTenantDetail(guid) {
            let that = this;
            let req = {
                tenantGuid: guid
            }
            that.api.get(`/${serverConfig.msCustomerService}/tenant-expand/get-detail-by-tenant-guid`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let data = res.data.data;
                    if (!data) return;
                    //公司成立时间
                    this.form.registerDate = data.registerDate;
                    //注册资本  
                    this.form.registerCapitalAmount = data.registerCapitalAmount;
                    // 企业地址 
                    this.form.address = data.address;
                    //公司法人
                    this.form.juridicalPerson = data.juridicalPerson;
                    //销售规模（元）  
                    this.form.salesScaleAmount = data.salesScaleAmount;
                    //联系人
                    this.form.contacts = data.contacts;
                    //客户定级
                    this.form.customerGrade = data.customerGrade||null;
                    //是否上市
                    this.form.isIpo = data.isIpo||'N';
                    //公司简称
                    this.form.abbreviation = data.abbreviation;
                    //   行业地位 
                    this.form.businessTypeList= data.businessTypeList
                    this.form.companyType = data.organizationForm
                    
                    this.form.industryPosition = data.industryPosition
                    this.form.businessScale = data.businessScale
                    this.form.marketingExpensePayObject = data.marketingExpensePayObject
                    this.form.invoiceType = data.invoiceType
                    this.form.hasItDept = data.hasItDept
                    this.form.itAbility = data.itAbility

                    this.form.circulateType = data.circulateType
                    this.form.businessScopeList = data.businessScopeList

                    this.form.mainProductCategoryList = data.mainProductCategoryList
                    this.form.staffTypeList = data.staffTypeList

                    this.form.staffVisitObjectList = data.staffVisitObjectList
                    this.form.linkSystemList = data.linkSystemList

                    this.form.province = data.province;
                    this.addressList = [];
                    if (data.province) {
                        this.addressList.push(data.province)
                    }
                    this.form.city = data.city;
                    if (data.city) {
                        this.addressList.push(data.city)
                    }
                    this.form.district = data.district;
                    if (data.district) {
                        this.addressList.push(data.district)
                    }
                    console.log( this.addressList);
                    this.form.venue = data.venue;

                    this.form.platformEnterpriseType = data.enterpriseCate;
                    this.form.contactsMobile = data.contactTel;
                    this.form.marketingExpensePayLimit = data.marketingExpenseYearPayLimit;
                    this.form.lawsuitType = data.stainType;
                    this.form.tenantTel = data.tel;
                    this.form.downstreamCustomerList = data.downstreamCustomer? [String(data.downstreamCustomer)]:[];
                    this.$forceUpdate();


                  
                } else {
                    that.$message.error(res.data.msg);
                }

            });
        },
        changeCityAndDis() {
            if (this.addressList.length == 3) {
                this.form.province = this.addressList[0]
                this.form.city = this.addressList[1]
                this.form.district = this.addressList[2]
            }
            if (this.addressList.length == 2) {
                this.form.province = this.addressList[0]
                this.form.city = this.addressList[1]
            }
            let venue = '';
            if (this.addressList.length) {
                if (this.addressList[0]) {
                    venue = this.province(this.addressList[0]);
                }
                if (this.addressList[1]) {
                    venue = this.province(this.addressList[0]) + '/' + this.city(this.addressList[1]);
                }
                if (this.addressList[2]) {
                    venue = this.province(this.addressList[0]) + '/' + this.city(this.addressList[1]) + '/' + this.district(this.addressList[2]);
                }
            }
            this.form.venue = venue;
        },
        province(val) {
            let pr = '';
            this.options.forEach(function (j) {
                if (j.value == val) {
                    pr = j.label;
                }
            });
            return pr;
        },
        city(val) {
            let ci = '';
            this.options.forEach(function (i) {
                if (i.children != null && i.children != '') {
                    i.children.forEach(function (j) {
                        if (j.value == val) {
                            ci = j.label;
                        }
                    });
                }
            });
            return ci;
        },
        district(val) {
            let di = '';
            this.options.forEach(function (i) {
                if (i.children != null && i.children != '') {
                    i.children.forEach(function (j) {
                        if (j.children != null && j.children != '') {
                            j.children.forEach(function (n) {
                                if (n.value == val) {
                                    di = n.label;
                                }
                            });
                        }
                    });
                }
            });
            return di;
        },
        choosePerson(type) {
            this.staffType = type;
            if (type == '1') {
                this.$refs.choosePerson.open(this.form.projectManagerGuid ? [this.form.projectManagerGuid] : []);
            }
            if (type == '2') {
                this.$refs.choosePerson.open(this.form.createProjectStaffGuid ? [this.form.createProjectStaffGuid] : []);
            }

        },
        onPersonSelect([personGuid, data, name]) {
            this.data = data;
            if (this.staffType == '1') {
                this.form.projectManagerGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
                this.form.projectManagerName = name || null;
            }
            if (this.staffType == '2') {
                this.form.createProjectStaffGuid = personGuid && personGuid.length > 0 ? personGuid[0] : null;
                this.form.createProjectStaffName = name || null;

            }
            console.log(this.form)

        },

        //提交申请
        saveReq() {
            if (!this.checkForm()) return;
            let form = this.form;
            let createProjectFileList = this.createProjectFileList;
            let gradeSurveyFileList = this.gradeSurveyFileList;
            let reqUrl;
            createProjectFileList.forEach(item => {
                item.fileName = item.name;
            })
            gradeSurveyFileList.forEach(item => {
                item.fileName = item.name;
            })
            if (form.cooperateFeeRate) {
                form.cooperateFeeRate = form.cooperateFeeRate.toString().replace(/[^\d.]/g, '')
            }
            if (form.businessFeeRate) {
                form.businessFeeRate = form.businessFeeRate.toString().replace(/[^\d.]/g, '')
            }
            if (form.salesScaleAmount) {
                form.salesScaleAmount = form.salesScaleAmount.toString().replace(/[^\d.]/g, '')
            }
            if (form.registerCapitalAmount) {
                form.registerCapitalAmount = form.registerCapitalAmount.toString().replace(/[^\d.]/g, '')
            }
            if (form.cooperateScaleAmount) {
                form.cooperateScaleAmount = form.cooperateScaleAmount.toString().replace(/[^\d.]/g, '')
            }
            if (form.businessFee) {
                form.businessFee = form.businessFee.toString().replace(/[^\d.]/g, '')
            }


            form.gradeSurveyFileList = gradeSurveyFileList;
            form.createProjectFileList = createProjectFileList;
            form.currentTenantGuid = localStorage.guid;
            form.isSendFlowFlag = 'Y';
            if (this.guid) {
                reqUrl = `/${serverConfig.msCustomerService}/projectApply/update`
                form.guid = this.guid;
            } else {
                reqUrl = `/${serverConfig.msCustomerService}/projectApply/add`
                form.guid = null;
            }
            this.fullscreenLoading = true;
            this.api.postJson(reqUrl, form).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

                    this.$message({
                        message: '提交申请成功',
                        type: 'success',
                    });
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });

        },
        //提交草稿
        saveTemp() {
            if (!this.form.createProjectStaffGuid) {
                this.$message.error('立项人不能为空')
                return false;
            }
            if (!this.form.tenantName) {
                this.$message.error('客户名称不能为空')
                return false;
            }
            let form = this.form;
            let createProjectFileList = this.createProjectFileList;
            let gradeSurveyFileList = this.gradeSurveyFileList;
            let reqUrl;
            createProjectFileList.forEach(item => {
                item.fileName = item.name;
            })
            gradeSurveyFileList.forEach(item => {
                item.fileName = item.name;
            })
            if (form.cooperateFeeRate) {
                form.cooperateFeeRate = form.cooperateFeeRate.toString().replace(/[^\d.]/g, '')
            }
            if (form.businessFeeRate) {
                form.businessFeeRate = form.businessFeeRate.toString().replace(/[^\d.]/g, '')
            }
            if (form.salesScaleAmount) {
                form.salesScaleAmount = form.salesScaleAmount.toString().replace(/[^\d.]/g, '')
            }
            if (form.registerCapitalAmount) {
                form.registerCapitalAmount = form.registerCapitalAmount.toString().replace(/[^\d.]/g, '')
            }

            if (form.cooperateScaleAmount) {
                form.cooperateScaleAmount = form.cooperateScaleAmount.toString().replace(/[^\d.]/g, '')
            }
            if (form.businessFee) {
                form.businessFee = form.businessFee.toString().replace(/[^\d.]/g, '')
            }
            form.gradeSurveyFileList = gradeSurveyFileList;
            form.createProjectFileList = createProjectFileList;
            form.currentTenantGuid = localStorage.guid;
            form.isSendFlowFlag = 'N';
            if (this.guid) {
                reqUrl = `/${serverConfig.msCustomerService}/projectApply/update`
                form.guid = this.guid;
            } else {
                reqUrl = `/${serverConfig.msCustomerService}/projectApply/add`
                form.guid = null;
            }
            this.fullscreenLoading = true;
            this.api.postJson(reqUrl, form).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.$message({
                        message: '保存成功',
                        type: 'success',
                    });
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.data.msg);
                }
            });
        },
        // getStaffList() {
        //     let req = {
        //         tenantGuid: localStorage.guid,
        //         staffType: 1,
        //     }
        //     this.api.postJson(`/${serverConfig.msPersonnelService}/staff/get-select-staff`, req).then((res) => {
        //         if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        //             console.log(res.data.data)
        //             this.staffList = res.data.data;
        //         } else {
        //             this.$message.error(res.data.data.msg);
        //         }
        //     });
        // },
        // 上传文件
        changeMainFile(file) {
            let isLt5M = file.file.size / 1024 / 1024 < this.fileSizeTip;
            if (!isLt5M) {
                this.$message.error(`上传文件大小不能超过${this.fileSizeTip}MB`);
                this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('fileName', file.file.name);
            this.createProjectFileList = [];
            this.fullscreenLoading = true;
            this.api.postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.createProjectFileList.push({
                        name: file.file.name,
                        path: res.data.data.data,
                    });
                    console.log(this.createProjectFileList)
                    this.$message({
                        message: '上传成功',
                        type: 'success',
                    });
                } else {
                    this.createProjectFileList = [];
                    this.$message.error('上传失败!');
                }
            }).catch(() => {
                this.$message('上传失败！');
            });
        },
        handleMainRemove() {
            this.createProjectFileList = [];
        },
        changeSubFile(file) {
            let isLt5M = file.file.size / 1024 / 1024 < this.fileSizeTip;
            if (!isLt5M) {
                this.$message.error(`上传文件大小不能超过${this.fileSizeTip}MB`);
                this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('fileName', file.file.name);
            this.gradeSurveyFileList = [];
            this.fullscreenLoading = true;
            this.api.postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.gradeSurveyFileList.push({
                        name: file.file.name,
                        path: res.data.data.data,
                    });
                    console.log(this.gradeSurveyFileList)
                    this.$message({
                        message: '上传成功',
                        type: 'success',
                    });
                } else {
                    this.gradeSurveyFileList = [];
                    this.$message.error('上传失败!');
                }
            }).catch(() => {
                this.$message('上传失败！');
            });
        },
        handleSubRemove() {
            this.gradeSurveyFileList = [];
        },
        checkForm() {
            if (!this.form.createProjectDate) {
                this.$message.error('立项时间不能为空')
                return false;
            }
            if (!this.form.createProjectStaffGuid) {
                this.$message.error('立项人不能为空')
                return false;
            }
            if (!this.form.tenantName) {
                this.$message.error('客户名称不能为空')
                return false;
            }
            if (!this.form.abbreviation) {
                this.$message.error('公司简称不能为空')
                return false;
            }
            if (!this.form.platformEnterpriseType) {
                this.$message.error('公司类型不能为空')
                return false;
            }
            if (!this.form.registerDate) {
                this.$message.error('公司成立时间不能为空')
                return false;
            }
            if (!this.form.registerCapitalAmount) {
                this.$message.error('注册资本不能为空')
                return false;
            }

            if (!this.form.companyType) {
                this.$message.error('公司组织形式不能为空')
                return false;
            }
            if (!this.form.industryPosition) {
                this.$message.error('行业地位不能为空')
                return false;
            }
            if (!this.form.businessScale) {
                this.$message.error('经营规模不能为空')
                return false;
            }
            if (!this.form.businessScopeList || this.form.businessScopeList.length == 0) {
                this.$message.error('经营范围不能为空')
                return false;
            }
            if (!this.form.mainProductCategoryList || this.form.mainProductCategoryList.length == 0) {
                this.$message.error('主营品种类型不能为空')
                return false;
            }
            if (!this.form.downstreamCustomerList || this.form.downstreamCustomerList.length == 0) {
                this.$message.error('主要下游客户不能为空')
                return false;
            }
            if (!this.form.businessTypeList || this.form.businessTypeList.length == 0) {
                this.$message.error('主营业务类型不能为空')
                return false;
            }
            if (!this.form.marketingExpensePayLimit) {
                this.$message.error('营销费用年支出额度不能为空')
                return false;
            }
            if (!this.form.marketingExpensePayObject) {
                this.$message.error('公司营销费用支出对象不能为空')
                return false;
            }
            if (!this.form.invoiceType) {
                this.$message.error('开票类型不能为空')
                return false;
            }
            if (!this.form.staffTypeList || this.form.staffTypeList.length == 0) {
                this.$message.error('业务员类型不能为空')
                return false;
            }
            if (!this.form.staffVisitObjectList || this.form.staffVisitObjectList.length == 0) {
                this.$message.error('业务人员日常拜访对象不能为空')
                return false;
            }
            if (!this.form.juridicalPerson) {
                this.$message.error('公司法人不能为空')
                return false;
            }
            if (!this.form.lawsuitType) {
                this.$message.error('司法官司不能为空')
                return false;
            }
            if (!this.form.itAbility) {
                this.$message.error('信息能力不能为空')
                return false;
            }
            if (!this.form.customerGrade) {
                this.$message.error('客户定级不能为空')
                return false;
            }
            if (!this.form.salesScaleAmount) {
                this.$message.error('年销售额不能为空')
                return false;
            }
            if (!this.form.customerSource) {
                this.$message.error('客户来源不能为空')
                return false;
            }

            if (!this.addressList || this.addressList.length == 0) {
                this.$message.error('所在省市区不能为空')
                return false;
            }

            if (!this.form.address) {
                this.$message.error('详细地址不能为空')
                return false;
            }




            if (!this.form.contacts) {
                this.$message.error('业务联系人不能为空')
                return false;
            }
            if (!this.form.contactsMobile) {
                this.$message.error('联系电话不能为空')
                return false;
            }
            if (!this.form.tenantTel) {
                this.$message.error('公司电话不能为空')
                return false;
            }

            if (!this.form.projectType) {
                this.$message.error('项目类型不能为空')
                return false;
            }

            if (!this.form.cooperateFeeRate) {
                this.$message.error('合作点数不(%)能为空')
                return false;
            }

            if (!this.form.cooperateScaleAmount) {
                this.$message.error('合作规模(元)不能为空')
                return false;
            }

            if (!this.form.projectRelationPerson) {
                this.$message.error('项目关系人不能为空')
                return false;
            }
            if (!this.createProjectFileList.length) {
                this.$message.error('立项申请表不能为空')
                return false;
            }
            if (!this.gradeSurveyFileList.length) {
                this.$message.error('客户分级表/需求调研表不能为空')
                return false;
            }
            return true;
        },
        //获取流程列表
        getApprovalList() {
            let userinfo = JSON.parse(localStorage.userInfo);
            let token = localStorage.token;
            if (this.guid && this.form.camundaInstanceId && this.form.camundaDeploymentId) {
                this.iframeSh = true;
                this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + this.form.camundaInstanceId + '&camundaDeploymentId=' + this.form.camundaDeploymentId + '&token=' + token;
                return;
            }
            let req = {
                tenantGuid: localStorage.guid,
                flowType: '00009',
                staffGuid: userinfo.staffGuid
            }
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    if (!res.data.data) {
                        this.$message.error('没有找到规则,请先联系运营人员设置当前部门的流程规则');
                        this.iframeSh = false;
                    } else {
                        this.iframeSh = true;
                        this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + res.data.data + '&token=' + token;
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        }
    }
};
</script> 